<div class="row">
    <!--    <div class="col-6">-->
    <!--        <div class="row">-->
    <!--            <div class="col-12">-->
    <!--                <app-stats-test></app-stats-test>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--    </div>-->

    <!--Projects-->
    <div class="col-md-8 col-12 text-center m-md-0 mb-15">
        <div class="row">
            <div class="col-12">
                <div class="card card-custom p-4">
                    <h1 class="report-name">Proiecte</h1>
                </div>
            </div>
            <div class="col-md-4 col-6 mt-5">
                <div class="card card-custom p-4">
                    <span class="d-block data-number">{{projectNumbers}}</span>
                    <span class="d-block text-muted">Toate Proiectele</span>
                </div>
            </div>
            <div class="col-md-4 col-6 mt-5">
                <div class="card card-custom p-4">
                    <span class="d-block data-number">{{activeProjectNumbers}}</span>
                    <span class="d-block text-muted">Proiecte Activate</span>
                </div>
            </div>
            <div class="col-md-4 col-6 mt-5">
                <div class="card card-custom p-4">
                    <span class="d-block data-number">{{archivedProjectNumbers}}</span>
                    <span class="d-block text-muted">Proiecte Arhivate</span>
                </div>
            </div>
        </div>
    </div>

    <!--Companies-->
    <div class="col-md-4 col-12 text-center">
        <div class="row">
            <div class="col-12">
                <div class="card card-custom p-4">
                    <h1 class="report-name">Companii</h1>
                </div>
            </div>
            <div class="col-12 mt-5">
                <div class="card card-custom p-4">
                    <span class="d-block data-number">{{allCompanies}}</span>
                    <span class="d-block text-muted">Toate Companiile</span>
                </div>
            </div>
        </div>
    </div>

    <!--Offers-->
    <div class="col-12 text-center mt-md-25 mb-md-25 mb-0 mt-15">
        <div class="row">
            <div class="col-12">
                <div class="card card-custom p-4">
                    <h1 class="report-name">Oferte</h1>
                </div>
            </div>
            <div class="col-md-3 col-6 mt-5">
                <div class="card card-custom p-4">
                    <span class="d-block data-number">{{offersNumber}}</span>
                    <span class="d-block text-muted">Toate Ofertele</span>
                </div>
            </div>
            <div class="col-md-3 col-6 mt-5">
                <div class="card card-custom p-4">
                    <span class="d-block data-number">{{sentOffers}}</span>
                    <span class="d-block text-muted">Oferte Trimise</span>
                </div>
            </div>
            <div class="col-md-3 col-6 mt-5">
                <div class="card card-custom p-4">
                    <span class="d-block data-number">{{acceptedOffers}}</span>
                    <span class="d-block text-muted">Oferte Aceptate</span>
                </div>
            </div>
            <div class="col-md-3 col-6 mt-5">
                <div class="card card-custom p-4">
                    <span class="d-block data-number">{{declinedOffers}}</span>
                    <span class="d-block text-muted">Oferte Respinse</span>
                </div>
            </div>
        </div>
    </div>

    <!--Joburi-->
    <div class="col-md-6 col-12 text-center mt-md-5 mt-15">
        <div class="row">
            <div class="col-12">
                <div class="card card-custom p-4">
                    <h1 class="report-name">Joburi</h1>
                </div>
            </div>
            <div class="col-6 mt-5">
                <div class="card card-custom p-4">
                    <span class="d-block data-number">{{allJobs}}</span>
                    <span class="d-block text-muted">Toate Joburile</span>
                </div>
            </div>
            <div class="col-6 mt-5">
                <div class="card card-custom p-4">
                    <span class="d-block data-number">{{activeJobs}}</span>
                    <span class="d-block text-muted">Joburi Active</span>
                </div>
            </div>
        </div>
    </div>

    <!--Candidates-->
    <div class="col-md-6 col-12 text-center mt-md-5 mt-15">
        <div class="row">
            <div class="col-12">
                <div class="card card-custom p-4">
                    <h1 class="report-name">Candidati</h1>
                </div>
            </div>
            <div class="col-12 mt-5">
                <div class="card card-custom p-4">
                    <span class="d-block data-number">{{candidates}}</span>
                    <span class="d-block text-muted">Candidati</span>
                </div>
            </div>
        </div>
    </div>

    <!--Contract-->
    <div class="col-12 text-center mt-md-25 mt-15">
        <div class="row">
            <div class="col-12">
                <div class="card card-custom p-4">
                    <h1 class="report-name">Contracte</h1>
                </div>
            </div>
            <div class="col-md-3 col-6 mt-5">
                <div class="card card-custom p-4">
                    <span class="d-block data-number">{{allContracts}}</span>
                    <span class="d-block text-muted">Toate Contractele</span>
                </div>
            </div>
            <div class="col-md-3 col-6 mt-5">
                <div class="card card-custom p-4">
                    <span class="d-block data-number">{{sendContracts}}</span>
                    <span class="d-block text-muted">Contracte Trimise</span>
                </div>
            </div>
            <div class="col-md-3 col-6 mt-5">
                <div class="card card-custom p-4">
                    <span class="d-block data-number">{{acceptedContracts}}</span>
                    <span class="d-block text-muted">Contracte Aceptate</span>
                </div>
            </div>
            <div class="col-md-3 col-6 mt-5">
                <div class="card card-custom p-4">
                    <span class="d-block data-number">{{declinedContracts}}</span>
                    <span class="d-block text-muted">Contracte Respinse</span>
                </div>
            </div>
            <div class="col-md-3 col-6 mt-5">
                <div class="card card-custom p-4">
                    <span class="d-block data-number">{{archivedContracts}}</span>
                    <span class="d-block text-muted">Contracte Arhivate</span>
                </div>
            </div>
        </div>
    </div>
</div>


